import React from 'react';
import { useLocale } from 'next-intl';
import PropTypes from 'prop-types';
import LoadingIndicator from '@components/atoms/loading-indicator/loadingIndicator';
import StyledFilterResults from './filter-results.style';
import Container from '../../../../layout/container/container';
import DateLine from './components/DateLine/date-line';
import Teaser from './components/Teaser/teaser';

const FilterResults = ({ loading, error, results }) => {
  const locale = useLocale();
  let queryParams = '';
  if (typeof window !== 'undefined') {
    queryParams = new URLSearchParams(window.location.search);
  }

  const renderContent = () => {
    if (loading) {
      return (
        <div className="filterResults__loading">
          <LoadingIndicator inverted />
        </div>
      );
    }

    if (error) {
      return <div className="filterResults__error">{error.toString()}</div>;
    }

    return Object.entries(results.results || {}).map(([date, dateGroup]) => (
      <React.Fragment key={date}>
        <DateLine date={new Date(date)} />
        {dateGroup.length === 0 ? (
          <div className="filterResults__noResults">
            {locale === 'de'
              ? 'Keine Ergebnisse für diesen Tag gefunden'
              : 'No Results found for this day'}
          </div>
        ) : (
          dateGroup.map(teaser => (
            <Teaser
              {...teaser}
              queryParams={queryParams}
              key={`teaser-${teaser.date}-${teaser.data.headline}`}
            />
          ))
        )}
      </React.Fragment>
    ));
  };

  return (
    <StyledFilterResults>
      <Container className="filterResults__container">{renderContent()}</Container>
    </StyledFilterResults>
  );
};

FilterResults.propTypes = {
  settings: PropTypes.shape().isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.oneOf([PropTypes.bool, PropTypes.string, PropTypes.shape()]).isRequired,
  results: PropTypes.shape({
    results: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.shape()).isRequired
      })
    )
  })
};

export default FilterResults;
